export default "__VITE_ASSET__C4Vi15A7__"